var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatPulling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6759 16.917C2.98812 17.6392 3.5184 18.0003 4.26673 18.0003H15.7334C16.4823 18.0003 17.0126 17.6392 17.3242 16.917C17.6359 16.1947 17.5331 15.5372 17.0159 14.9445L12.8876 9.66697V4.66697H14.2776C14.3846 4.66998 14.491 4.65055 14.59 4.60993C14.6891 4.56931 14.7785 4.50841 14.8526 4.43114C14.928 4.35142 14.9869 4.25761 15.0259 4.15507C15.0649 4.05254 15.0833 3.9433 15.0801 3.83364C15.0833 3.72397 15.0649 3.61474 15.0259 3.5122C14.9869 3.40967 14.928 3.31585 14.8526 3.23614C14.7785 3.15887 14.6891 3.09796 14.59 3.05734C14.491 3.01673 14.3846 2.9973 14.2776 3.0003H5.72257C5.61557 2.9973 5.50913 3.01673 5.4101 3.05734C5.31107 3.09796 5.22164 3.15887 5.14757 3.23614C5.07233 3.31592 5.01358 3.40976 4.97468 3.5123C4.93579 3.61483 4.91751 3.72403 4.9209 3.83364C4.9209 4.07475 4.99673 4.27391 5.1484 4.43114C5.22247 4.50841 5.3119 4.56931 5.41093 4.60993C5.50996 4.65055 5.6164 4.66998 5.7234 4.66697H7.1134V9.66697L2.9834 14.9445C2.46673 15.5367 2.36423 16.1942 2.6759 16.917ZM6.39007 13.2311H13.6101L11.2834 10.2778V4.66697H8.71673V10.2778L6.39007 13.2311Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatPulling);
export default __webpack_public_path__ + "static/media/stat-pulling.7ef643720305617598028c2ccef290e8.svg";
export { ForwardRef as ReactComponent };